<div [ngbPopover]="popoverElement" container="body" [popoverTitle]="" triggers="manual" #pOver="ngbPopover">
  <button [disabled]="disabled" (click)="btnClick(pOver)" class="position-relative fw-500 btn btn-icon" [ngClass]="{'btn-gray-600': !url && !invalid, 
  'btn-success': url && !invalid,
  'btn-danger' : invalid,
  'disabled': loading || disabled
}">
    <i class="mdi" [ngClass]="{
  'mdi-loading mdi-spin': loading,
  'mdi-camera': !loading
}"></i>
    <div *ngIf="required" class="required" [ngClass]="{'text-danger': !invalid, 'text-white': invalid}" >*</div>
  </button>

  <ng-template #popoverElement>
    <img *ngIf="!erroImg" style="width: 250px; height: 250px; object-fit: contain;" src="{{url}}" (error)="erroImgEvent()" alt="">
    <div *ngIf="erroImg" style="width: 250px; height: 250px;" class="d-flex align-items-center justify-concent-center p-2" >
      <span class="text-muted text-center fw-300 f-18">ERRO AO CARREGAR IMAGEM</span>
    </div>
    <div class="d-flex mt-2">
      <button *ngIf="showEditBtn" (click)="openEditor()" class="btn btn-icon btn-sm btn-info">
        <i class="mdi mdi-pencil"></i>
      </button>
      <button *ngIf="showDeleteBtn" (click)="deleteImage()" class="btn btn-icon btn-sm btn-danger mx-3">
        <i class="mdi mdi-delete"></i>
      </button>
      <a *ngIf="showLinkBtn" (click)="openLink()" rel="noopener noreferrer" target="_blank" [href]="url" class="btn btn-icon btn-sm btn-primary ml-auto">
        <i class="mdi mdi-open-in-new"></i>
      </a>  
    </div>
  </ng-template>
</div>
<app-image-editor-modal [image]="base64" (imageChange)="setImageBase64($event)"></app-image-editor-modal>